import { mapMutations, mapGetters, mapActions } from "vuex";
import {} from "@/store/mutation-types";

import StarRating from "vue-star-rating";

export default {
    name: "favourite-product",
    props: ["product"],
    computed: {
        ...mapGetters({
            popupFastBuy: `card/popupFastBuy`,
            basket: `basket/basket`,
            count: `basket/count`,
        }),
    },
    components: {
        StarRating,
    },
    methods: {
        ...mapMutations({
            changeFastBuy: `card/CHANGE_POPUP_FAST_BUY`,
            addBasket: `basket/ADD_ITEM_TO_BASKET`,
        }),
        ...mapActions({
            removeFromFavourite: `favorites/REMOVE_PRODUCT_IN_FAVORITE`,
            fetchFavourite: `favorites/GET_FAVORITES_LIST`,
        }),
        removeItem(product) {
            this.removeFromFavourite(product)
                .then(() => {
                    this.$toasted.success(this.$t("successRemoveFromFavourites"));
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 422) {
                        console.log(this.validationErrors);
                    }
                });
        },
        changePopup(status) {
            this.changeFastBuy({
                show: status,
                product_id: this.product.id,
                count: this.product.select_count ? this.product.select_count : 1,
            });
        },
        addToBasket(product) {
            this.addBasket({
                min_price: this.product.min_price,
                select_count: this.count,
                select_price: product.discount_price ? product.discount_price : product.price,
                ...product,
            });
            this.$toasted.success(this.$t("successAddBasket"));
        },
    },
};
